import React, { Component } from 'react'
import { Upload, PreviewModal } from 'hlj-components'
import Style from './style.module.less'
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons'
import { message } from 'hljd'

export default class extends Component {
  onAdd = (file, imagePath, { width, height }) => {
    const { value, onChange, max } = this.props
    const image = {
      imagePath,
      width,
      height
    }
    if (value) {
      if (max && value.length >= max) {
        message.error(`最多上传${max}张图片`)
        return
      }
      onChange([...value, image])
    } else {
      onChange([image])
    }
  }

  onRemove = index => () => {
    const { value, onChange } = this.props
    value.splice(index, 1)
    onChange(value)
  }

  onError = (up, err, errTip) => {
    if (err.code === plupload.FILE_SIZE_ERROR) {
      message.warn(`文件大小超过10M，请重新选择`)
    }
  }

  render() {
    const { value = [], max } = this.props

    return (
      <div>
        <div className={Style.list}>
          {value.map((item, index) => {
            return (
              <div className={Style['list-item']} key={index}>
                <img
                  style={{ width: '100%' }}
                  src={`${item.imagePath}?imageView2/1/w/120/h/120`}
                />
                <div className={Style.bg} />
                <div className={Style.operation}>
                  <EyeOutlined
                    onClick={() =>
                      PreviewModal.open({
                        children: <img src={item.imagePath} />
                      })
                    }
                  />
                  <DeleteOutlined onClick={this.onRemove(index)} />
                </div>
              </div>
            )
          })}
          {!(max && value.length >= max) && (
            <Upload
              style={{
                width: '120px',
                height: '120px'
              }}
              multiple={true}
              onOk={this.onAdd}
              onError={this.onError}
              onDelete={(e, s, d) => console.log(e, s, d, 'onDelete')}
              description={
                <div style={{ color: '#666', lineHeight: 1.5 }}>
                  <p>上传图片</p>
                </div>
              }
              filters={{
                mime_types: [
                  {
                    title: 'images files',
                    extensions: 'jpg,png,jpeg,bmp'
                  }
                ]
              }}
              max_file_size="10mb"
            />
          )}
        </div>
      </div>
    )
  }
}
